module.exports = __webpack_public_path__ + "img/avatar5.42ce8bbb.png";